import type { ConditionOperator, ViewFilterModifier } from "@regrello/graphql-api";
import { RegrelloFormFieldFilterType } from "../../../v1_deprecated/filterKinds/base";

export type RegrelloFilterDefinition_DateValue_ExactValueType = {
  type: "exactDate";
  dateString: string | null;
};

/** A type that describes the ways in which a __date__ value can be filtered. */
export type RegrelloFilterDefinition_DateValue = {
  type: "date";
  filter:
    | {
        operator: "EQUALS";
        value: RegrelloFilterDefinition_DateValue_ExactValueType;
        modifier?: ViewFilterModifier;
      }
    | {
        operator: "LESS_THAN";
        value: RegrelloFilterDefinition_DateValue_ExactValueType;
        modifier?: ViewFilterModifier;
      }
    | {
        operator: "GREATER_THAN";
        value: RegrelloFilterDefinition_DateValue_ExactValueType;
        modifier?: ViewFilterModifier;
      };
};

export const regrelloFilterOperators_DateValue: Record<RegrelloFilterDefinition_DateValue["filter"]["operator"], true> =
  {
    EQUALS: true,
    GREATER_THAN: true,
    LESS_THAN: true,
  };

export function getRegrelloDefaultFilterDefinitionDateValue(): RegrelloFilterDefinition_DateValue {
  return {
    type: "date",
    filter: {
      operator: "EQUALS",
      value: { type: "exactDate", dateString: null },
    },
  };
}

export function getRegrelloFilterDefinitionDateValue(
  operator: ConditionOperator,
  value: string | null | undefined,
  values: string[] | null | undefined,
): RegrelloFilterDefinition_DateValue | undefined {
  if (operator === "EQUALS" || operator === "GREATER_THAN" || operator === "LESS_THAN") {
    if (value == null) {
      console.warn("Date value must not be null for date filter:", operator);
      return undefined;
    }

    return {
      type: RegrelloFormFieldFilterType.DATE,
      filter: {
        operator,
        value: {
          type: "exactDate",
          dateString: value,
        },
      },
    };
  }

  // (elle): The EQUAL date filter was converted to use the BETWEEN operator before sending an API request to the
  // backend for accurate time zone comparisons. Now, converting it back to EQUALS to ensure correct display in the UI.
  // This is achieved by using the minimum UTC date from the BETWEEN range, adjusted to the local time zone.
  if (operator === "BETWEEN") {
    if (values?.[0] == null) {
      console.warn("Date values must not be null for operator:", operator);
      return undefined;
    }

    // Convert the min UTC date to local date
    const minUTCDate = new Date(values[0]);
    const localDate = minUTCDate.toLocaleDateString();

    return {
      type: RegrelloFormFieldFilterType.DATE,
      filter: {
        operator: "EQUALS",
        value: {
          type: "exactDate",
          dateString: localDate,
        },
      },
    };
  }

  console.warn("Unrecognized operator for date filter:", operator);
  return undefined;
}
